/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../base/BaseComponent";
import $ from "jquery";
export default class Position extends BaseComponent {
    static defaultProps = {
        backList:[],
        onRef: () => {
        },
    };
    static propTypes = {
        backList:PropTypes.array.isRequired,//返回数组
    };

    constructor(props) {
        super(props);
        this.state={
            virtualFileId:'',
            Id:'',
            backList:[],
            newBackList:[],
            isOnclick:false,
            num:0
        }
    }
    componentWillMount() {}
    componentDidMount() {
         this.props.onRef(this)
    }
    render() {
        return (
            <div style={{display:'flex'}} >
                <span>&nbsp;当前位置：</span>
                {
                    this.state.backList.map((item, index) => {
                        let showLength = 3;
                        if(index ===0 && this.state.backList.length>(index + showLength)){
                            return <span style={{cursor: 'pointer'}} key={index} title={this.state.backList[0].name}>{ this.state.backList[0].newName}&nbsp;{'>'}&nbsp;</span>
                        }
                        if((index + showLength + 1) < this.state.backList.length){
                            return <span></span>
                        }
                        if((index + showLength + 1) === this.state.backList.length){
                            return <span key={index}>&nbsp;...&nbsp;{'>'}&nbsp;</span>
                        }
                        if (index === this.state.backList.length - 1) {
                            return (<span key={index}   title={item.name}>{item.newName}</span>)
                        } else {
                            return (<span key={index}  className={item.noClickFlag?'':'ant-tabs-tab-active'} onClick={() => {
                                if(!item.noClickFlag){
                                    if(index!=this.state.backList.length-1){
                                        this.itemNavClick(item, index)
                                    }
                                }
                            }}
                                style={{cursor: 'pointer'}}  title={item.name}>{item.newName}&nbsp;{'>'}&nbsp;</span>
                            )
                        }
                    })
                }
                {/*可点击的个数大于1*/}
                {this.state.num > 1 ?
                    <span className={'ant-tabs-tab-active'}  onClick={() => this.goBackNav()}
                          style={{cursor: 'pointer',marginLeft:5}}>|&nbsp;&nbsp;返回上一级&nbsp;</span> : null}
            </div>
        )
    }
    //nav每一项点击
    itemNavClick(item, index) {
        this.props.onSaveCallback&&this.props.onSaveCallback(item.id);
        this.props.updateBtnStatus&&this.props.updateBtnStatus(this.state.num)
    }
    goBackNav(){
            let record = this.state.backList[this.state.backList.length - 2];
            if (parseInt(record.id)<10) {
                this.state.backList = this.state.newBackList;
                this.state.num = 1;
                this.setState({},()=>{
                    this.props.onSaveCallback && this.props.onSaveCallback(record.id);
                })
            }else {
                this.state.backList.splice(this.state.backList.length - 1, 1);
                this.props.onSaveCallback && this.props.onSaveCallback(record.id);
                this.props.updateBtnStatus && this.props.updateBtnStatus(this.state.num)
            }
    }
    //获取当前位置
    getPosition=(currentId,RootId,List)=>{
        if(List){
            List&&List.length&&List.forEach((item,index)=>{
                let name = '';
                if(item.name.length>10){
                    name= (item.name).substring(0, 10) + "...";
                }else{
                    name = item.name
                }
                item.newName = name
            });
        }
        let parms={
            parentVirtualFileId:RootId,
            sonVirtualFileId:currentId,
        };
        this.request({
            url: "/cm-sites-storage-management/zykFile/getAllPatent",
            method: "get",
            body: parms,
            loading: false,
            callBack: (data) => {
                if(data&&data.length){
                    data&&data.length&&data.forEach((item)=>{
                        let name = '';
                        if(item.name.length>10){
                            name= (item.name).substring(0, 10) + "...";
                        }else{
                            name = item.name
                        }
                        item.newName = name
                    });
                }
                if(List){
                   this.state.backList =List;
                   this.state.newBackList =List;
                    if(data&&data.length){
                        
                        this.state.backList=[...this.state.backList,...data];
                        this.state.num = this.state.backList.length;
                    }else{
                       
                        this.state.backList=this.state.newBackList;
                        this.state.num =1;
                    }
                }else{
                    if(data){
                        let num = 0;
                        data&&data.length&&data.forEach((item)=>{
                            if(!item.noClickFlag){
                                num++
                            }
                        });
                        this.state.num =num;
                        this.state.backList = data;

                    }
                }
                this.setState({},()=>{
                    this.props.updateBtnStatus&&this.props.updateBtnStatus(this.state.num)

                })
            }
        });
    }
}